<script>
export default {
  name: 'ProfileNotRegistered',
  computed: {
    homeHref() {
      if (typeof window === 'undefined') {
        return '/'
      }
      const meta = document.querySelector('meta[name="app-url"]')
      if (meta && meta.content) {
        return meta.content.replace(/\/?$/, '/')
      }
      return `${window.location.origin}/`
    }
  }
}
</script>

<template>
  <div class="profile-guest left flex flex-xy-center">
    <div class="profile-guest-card left">
      <p class="profile-guest-title left">
        Пока нет данных в личном кабинете
      </p>
      <p class="profile-guest-text left">
        Отчёты появляются, когда в нашей системе есть договор, привязанный к вашему аккаунту и номеру телефона.
        Если вы ещё не клиент или договор пока не завели в отчёты — загляните на основной сайт: там контакты и описание услуг.
      </p>
      <a
        :href="homeHref"
        class="profile-guest-btn left flex flex-xy-center"
        rel="noopener noreferrer"
      >
        Перейти на главный сайт
      </a>
    </div>
  </div>
</template>

<style scoped>
.profile-guest {
  min-height: 60vh;
  width: 100%;
  padding: 6rem 4rem;
  box-sizing: border-box;
  color: #000;
}
.profile-guest-card {
  max-width: 72rem;
  text-align: center;
  color: #000;
}
.profile-guest-title {
  font-size: 4.8rem;
  font-weight: 600;
  line-height: 1.2;
  margin: 0 0 3rem;
  color: #000;
}
.profile-guest-text {
  font-size: 3rem;
  line-height: 1.45;
  margin: 0 0 4rem;
  color: #000;
}
.profile-guest-btn {
  display: inline-flex;
  min-height: 9rem;
  padding: 0 5rem;
  border-radius: 1.2rem;
  background: #4a90d9;
  font-size: 3.2rem;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s ease;
}
.profile-guest-btn:hover {
  background: #3a7bc8;
}
</style>
